import React from "react";
import storage from "utils/storage";

export const SharedCommunityMain = () => {
  const token = storage.get("humlog_authToken");
  if (!token) {
      window.location.href = `${window.location.origin}/homepage`;
  }
  return (<></>)
}